//These Error Codes are handled manually

import { ErrorCodes } from '../enums/error-codes';

export const exceptionalErrorCodes = [
  ErrorCodes.NationalIdAlreadyExistWithDiffPhoneNumber,
];
